import React, { useState } from 'react'
import { useGetServersByCategoryQuery } from '../RTK/ApiRequests'
import { useLocation } from 'react-router-dom';
import LocalServer from '../components/LocalServer';
import PremServer from '../components/PremServer';
import styled from 'styled-components';
import Loader from '../components/Loader';

const Servers = ({ isFeatured }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const category = queryParams.get('category');

  const { data, isLoading, isError } = useGetServersByCategoryQuery({
    category: !isFeatured ? category : 'featured',
    page: currentPage,
  });

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <Loader />;
  }

  const totalPages = data?.totalPages;

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <ServerWrapper>
      <h1>{!isFeatured ? category : 'Featured'} Servers</h1>
      <ServersList>
        {data?.totalPages === 0 ? (
          <h1>There are currently 0 Premium servers for {category}.</h1>
        ) : (
          data?.servers?.map((currElem, index) => {
            if (currElem.isPremium) {
              return <PremServer key={index} isEdit={false} serverInfo={currElem} />;
            }
          })
        )}
        {data?.totalPages === 0 ? (
          <h1>There are currently 0 Local servers for {category}.</h1>
        ) : (
          data?.servers?.map((currElem, index) => {
            if (!currElem.isPremium) {
              return <LocalServer key={index} isEdit={false} serverInfo={currElem} index={index + 1} />;
            }
          })
        )}
      </ServersList>
      <Pagination>
        <button onClick={handlePreviousPage} disabled={currentPage === 1}>
          Previous
        </button>
        <span>{currentPage} / {totalPages}</span>
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
          Next
        </button>
      </Pagination>
    </ServerWrapper>
  );
};

const ServerWrapper = styled.section`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 5rem;

  h1 {
    font-size: 5rem;
    font-weight: 500;
    text-align: center;
    padding-top: 5rem;
  }

  #addServer {
    background-color: #58678c;
    display: block;
    border: none;
    color: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 20px;
    padding: 1rem;
    text-transform: uppercase;
    cursor: pointer;
    width: 50%;
    margin: 3rem auto;
  }
`;

const ServersList = styled.section`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  align-items: center;
  margin-top: 5rem;
  margin-bottom: 5rem;

  h1 {
    font-size: 3rem;
  }
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  button {
    background-color: #3ba61c;
    color: #fff;
    padding: 8px 16px;
    border: none;
    margin: 0 5px;
    cursor: pointer;
    outline: none;
    border-radius: 5px;
    font-size: 16px;

    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }
  }
`;

export default Servers;
